export default token => {
  if (!token) {
    return;
  }

  let obj = JSON.parse(atob(token.split('.')[1]));
  return obj.rl;
};


// WEBPACK FOOTER //
// ./src/utils/get_role_from_token.js